import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=2155de22&scoped=true"
import script from "./SideCart.vue?vue&type=script&lang=js"
export * from "./SideCart.vue?vue&type=script&lang=js"
import style0 from "./SideCart.vue?vue&type=style&index=0&id=2155de22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2155de22",
  null
  
)

export default component.exports